export default function Error(props) {
  return (
    <h1 className="text-center text-3xl font-bold my-5">404 error not found</h1>
  );
}
